import { normalizeClassroom } from "./normalizeClassroom";

export function buildClassroomUrl(
  route: string,
  slug: string,
  classroom: string,
  utmSuffix: string
): string {
  return `${route}/${slug}?classroom=${encodeURIComponent(normalizeClassroom(classroom))}${utmSuffix}`;
}
